'use strict';

import {observable, configure, action, makeObservable, flow} from "mobx";
configure({enforceActions: 'always'});

import appStore from '@uw-it-sis/lib-react/lib/AppStore';
import {States} from '@uw-it-sis/lib-react/lib/AppConstants';

import api from '../lib/Api';

class AddressStore {
    state = States.initial;

    exceptionUtils = appStore.getExceptionUtils();

    formData = {};

    constructor() {
        makeObservable(this, {
            state: observable,
            formData: observable,
            mount: action
        })
    }

    mount = flow(function* () {
        try {
            this.state = States.pending;
            this.formData = yield api.getAddress();
            this.state = States.done;
        } catch (e) {
            this.exceptionUtils.handleException(e);
            this.state = States.error;
        }
    }.bind(this));
}

export default new AddressStore();